import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { thunkSetBetSliderAmount } from '../../../../redux/actions/pokerActions';
import { useAppDispatch } from '../../../../redux/store';
import { SET_BET_BUTTON_BACKGROUND_COLOR_NUM, SET_BET_BUTTON_BACKGROUND_HOVER_COLOR_NUM } from '../../../../styles/colors';
import { Button } from '../../pixiComponents/button';
export const ALL_SET_BET_ACTION_PROPERTIES = {
    '2x': {
        label: '2X',
        labelPixiDataType: 'set-bet-2x-button-label'
    },
    '3x': {
        label: '3X',
        labelPixiDataType: 'set-bet-3x-button-label'
    },
    '5x': {
        label: '5X',
        labelPixiDataType: 'set-bet-5x-button-label'
    },
    'quarter-pot': {
        label: '1/4',
        labelPixiDataType: 'set-bet-quarter-pot-button-label'
    },
    'half-pot': {
        label: '1/2',
        labelPixiDataType: 'set-bet-half-pot-button-label'
    },
    'three-quarter-pot': {
        label: '3/4',
        labelPixiDataType: 'set-bet-three-quarter-pot-button-label'
    },
    pot: {
        label: 'POT',
        labelPixiDataType: 'set-bet-pot-button-label'
    },
    max: {
        label: 'MAX',
        labelPixiDataType: 'set-bet-max-button-label'
    }
};
export const SetBetButton = ({ setBetAction, bounds }) => {
    const dispatch = useAppDispatch();
    const onClick = useCallback(() => {
        dispatch(thunkSetBetSliderAmount(setBetAction.betSliderAmount));
    }, [dispatch, setBetAction.betSliderAmount]);
    const { label, labelPixiDataType } = ALL_SET_BET_ACTION_PROPERTIES[setBetAction.setBetActionType];
    return (_jsx(Button, { pixiObjectData: { type: 'set-bet-button' }, onClick: onClick, labelProperties: {
            label,
            bitmapTextStyleType: 'set-bet-button-label',
            labelPixiDataType
        }, paddingH: 1, bounds: bounds, backgroundColor: SET_BET_BUTTON_BACKGROUND_COLOR_NUM, backgroundHoverColor: SET_BET_BUTTON_BACKGROUND_HOVER_COLOR_NUM, radius: 6 }));
};
